import {config as yesNoOverdueColumn} from '../../common/YesNoOverdueColumn';

export const prop = 'hasAPPICSO';
export const id = 'picOnAuditPlanColumn';

export const config = (labels) =>
	yesNoOverdueColumn({
		fullId: id,
		label: labels.picSignoffOnAuditPlan,
		prop,
		width: 'minmax(var(--px-210), 2fr)',
		isOverdue: (item) => item[prop] === false && item.isPartAPSODlyd === true
	});
